import PouchDB from "pouchdb-browser";

export const ordersDB = new PouchDB("offline_orders");
export const productsDB = new PouchDB("offline_products");
export const categoriesDB = new PouchDB("offline_categories");
export const tablesDB = new PouchDB("offline_tables");
